import { render, staticRenderFns } from "./signTrend.vue?vue&type=template&id=584f08a6&scoped=true&"
import script from "./signTrend.vue?vue&type=script&lang=js&"
export * from "./signTrend.vue?vue&type=script&lang=js&"
import style0 from "./signTrend.vue?vue&type=style&index=0&id=584f08a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584f08a6",
  null
  
)

export default component.exports